
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rules-editor",
      function () {
        return require("private-next-pages/rules-editor.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rules-editor"])
      });
    }
  